<template>
  <path pid="0" d="M16.5 10a1 1 0 001 1h6a1 1 0 00.93-.63.92.92 0 00.07-.37V4a1 1 0 00-2 0v3.69l-2.93-2.76a10 10 0 00-16.5 3.74A1 1 0 005 9.33a8 8 0 0113.23-3L21 9h-3.5a1 1 0 00-1 1zM15.71 23.75a10 10 0 007.22-6.42 1 1 0 10-1.88-.66 8 8 0 01-13.23 3L5 17h3.5a1 1 0 000-2h-6a1 1 0 00-.93.63.92.92 0 00-.07.37v6a1 1 0 002 0v-3.69l2.93 2.76a10 10 0 009.28 2.68z"/>
</template>
